import React, { useState, useEffect, useRef, useCallback } from "react";
import AsyncSelect from "react-select/async";
import { customFetch } from '../apiClient';
// ✅ DYNAMIC STYLES FOR REACT SELECT
const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '32px',
    fontSize: '13px',
    borderRadius: '4px',
    borderColor: state.isFocused ? 'var(--theme-color, #0088cc)' : '#ced4da',
    boxShadow: state.isFocused ? '0 0 0 2px color-mix(in srgb, var(--theme-color, #0088cc), transparent 85%)' : 'none',
    '&:hover': { borderColor: 'var(--theme-color, #0088cc)' },
    borderWidth: '1px'
  }),
  menu: (base) => ({ ...base, zIndex: 9999, borderRadius: '6px' }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  option: (base, state) => ({
    ...base,
    fontSize: '13px',
    padding: '6px 10px',
    backgroundColor: state.isSelected 
      ? 'var(--theme-color, #0088cc)' 
      : state.isFocused 
        ? 'color-mix(in srgb, var(--theme-color, #0088cc), white 90%)' 
        : 'white',
    color: state.isSelected ? 'white' : '#333',
    cursor: 'pointer',
    '&:active': { backgroundColor: 'var(--theme-color, #0088cc)', color: 'white' }
  }),
  placeholder: (base) => ({ ...base, color: '#6c757d', fontSize: '13px' })
};

// ISO string fallback ki jagah Local Date Format use karein
  const localToday = new Date().toLocaleDateString('en-CA');

function initItem() {
  return {
    medID: null, medicineName: "", category: "", companyName: "", packSize: "",
    unit: "", medicinecomposition: "", entryDate: new Date().toISOString().slice(0, 10),
    mrp: "", qty: "", oldqty: "", freeQty: "", totQtyInPcs: 0, pRate: "", gstP: "", hsnCode: "",
    mfgDate: "", expDate: "", batchNo: "", inScheme: "", piece: "", leaf: "",
    freeLeaf: "", freePiece: "", sRate: "", saleDis: "", dis: "", cd: "", cdInDis: "",
    taxable: 0, gstAmt: 0, totals: 0,
  };
}

const round2 = (v) => (Number.isFinite(v) ? parseFloat(v.toFixed(2)) : 0);
const getToken = () => sessionStorage.getItem("token") || "";

const MedPurchaseEditModal = ({ show, purchaseData, onClose, onUpdate }) => {
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [items, setItems] = useState([]);
 const [currentItem, setCurrentItem] = useState(() => initItem());
  const [billDate, setBillDate] = useState("");
  const [billNo, setBillNo] = useState("");
  const [remarks, setRemarks] = useState("");
  const [transport, setTransport] = useState("");
  const [headerCD, setHeaderCD] = useState(0);
  const [totals, setTotals] = useState({ totalTaxable: 0, totalGst: 0, totalAmount: 0 });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const formRef = useRef(null);
  const medicineSelectRef = useRef(null);

  useEffect(() => {
    if (show && purchaseData) loadPurchaseData();
  }, [show, purchaseData]);

  const loadPurchaseData = () => {
    try {
      if (purchaseData.vendor) {
        setSelectedVendor({
          vid: purchaseData.vendor.vid, vendorName: purchaseData.vendor.vendorName,
          gstin: purchaseData.vendor.gstin, mobile: purchaseData.vendor.mobile,
          address: purchaseData.vendor.address, stateName: purchaseData.vendor.stateName,
        });
      }


      const safeFormatDate = (dateStr) => {
          if (!dateStr) return "";
          return typeof dateStr === 'string' ? dateStr.split('T')[0] : new Date(dateStr).toLocaleDateString('en-CA'); 
          // 'en-CA' gives YYYY-MM-DD format locally without UTC conversion
      };
      if (purchaseData.summary) {
        setBillNo(purchaseData.summary.billNo || "");
       setBillDate(safeFormatDate(purchaseData.summary.billDate));
        setRemarks(purchaseData.summary.remarks || "");
        setTransport(purchaseData.summary.transports || "");
        setHeaderCD(purchaseData.summary.cd || 0);
      }
      if (purchaseData.items && purchaseData.items.length > 0) {
        const loadedItems = purchaseData.items.map((item) => {

          const baseItem = {

          medID: item.medID, medicineName: item.medicine || "", category: item.groupName || "",
          companyName: item.companyName || "", packSize: item.iUnit || "", unit: item.mUnit || "",
          medicinecomposition: item.mediInUnit || "",
          entryDate: safeFormatDate(item.entryDate),
          mrp: item.mrp || "", qty: item.qty || "", oldqty: item.qty || "", freeQty: item.freeqty || "",
          totQtyInPcs: item.totQtyInPcs || 0, pRate: item.pRate || "", gstP: item.gstp || "", hsnCode: item.hsncode || "",
        mfgDate: safeFormatDate(item.mfgDate),
            expDate: safeFormatDate(item.expDate),
          batchNo: item.batchNo || "", inScheme: item.inScheme || "", piece: item.piece || "",
          leaf: item.leaf || "", freeLeaf: item.freeLeaf || "", freePiece: item.freePiece || "",
          sRate: item.sRate || "", saleDis: item.saleDis || "", dis: item.dis1 || item.diS1 || "", cd: item.cd || "", cdInDis: item.cdindis || "",
          taxable: item.taxable || 0, gstAmt: item.gstamt || 0, totals: item.totals || 0,
      };

          // 🚀 YAHI HAI ASLI STEP: recalcItem ko call karein
          // Isse Leaf aur Piece ke basis par 'totQtyInPcs' aur 'Totals' recalculate ho jayenge
          return recalcItem(baseItem);
        });
        setItems(loadedItems);
      }
    } catch (err) { setError("Failed to load purchase data"); }
  };

  useEffect(() => {
    setTimeout(() => {
      const firstInput = formRef.current?.querySelector('select, input:not([type="hidden"]), .react-select__input input');
      if (firstInput) firstInput.focus();
    }, 300);
  }, []);

  const handleKeyDown = (e) => {
    const isInsideAsyncSelect = e.target.closest('.react-select__control') || e.target.classList?.contains('react-select__input');
    if (isInsideAsyncSelect && e.key === 'Enter') return;
    const isReactSelectMenuOpen = document.querySelector('.react-select__menu');
    if (isReactSelectMenuOpen) return;

    const focusableElements = formRef.current?.querySelectorAll(
      'input:not([disabled]):not([readonly]):not([type="hidden"]):not([tabindex="-1"]), ' +
      '.react-select__input input:not([disabled]):not([readonly]):not([type="hidden"]), ' +
      'select:not([disabled]):not([tabindex="-1"]), textarea:not([disabled]):not([readonly]), ' +
      'button:not([disabled]):not([tabindex="-1"])'
    );

    if (!focusableElements || focusableElements.length === 0) return;
    const currentIndex = Array.from(focusableElements).indexOf(e.target);
    const isAddButton = e.target.textContent?.includes("Add Medicine") || e.target.closest('button')?.textContent?.includes("Add Medicine");

    if (e.key === "Tab") return;

    if (e.key === "Enter") {
      if (isAddButton) { e.preventDefault(); handleAddItem(); return; }
      if (currentIndex === focusableElements.length - 1) { e.preventDefault(); e.target.closest("form").requestSubmit(); return; }
      e.preventDefault();
      const nextIndex = Math.min(focusableElements.length - 1, currentIndex + 1);
      focusableElements[nextIndex]?.focus();
    }
  };

  useEffect(() => {
    const handler = (e) => { if (formRef.current && e.target.closest("form") === formRef.current) handleKeyDown(e); };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [handleKeyDown]);

  const loadVendorOptions = async (inputValue) => {
    if (!inputValue) return [];
    try {
    const res = await customFetch(`/VendorDT/search?name=${encodeURIComponent(inputValue)}`);
    if (!res.ok) return [];
      const data = await res.json();
      return data.map((v) => ({ value: v.vid, label: `${v.vendorName} (${v.gstin || "No GST"})`, data: v }));
    } catch { return []; }
  };

  const handleVendorChange = (selected) => { setSelectedVendor(selected ? selected.data : null); };

  const loadMedicineOptions = async (inputValue) => {
    if (!inputValue) return [];
    try {
     const res = await customFetch(`/MedicineDT/search?medicine=${encodeURIComponent(inputValue)}`);
    if (!res.ok) return [];
      const data = await res.json();
      return data.map((m) => ({ value: m.medID, label: m.medicine, data: m }));
    } catch { return []; }
  };

  const handleMedicineChange = (selected) => {
    if (!selected) { setCurrentItem(initItem()); return; }
    const m = selected.data;
    setCurrentItem((prev) => ({
      ...prev, 
      medID: m.medID, 
      medicinecomposition: m.mediInUnit, 
      medicineName: m.medicine,
      category: m.categoryName, 
      companyName: m.brandName, 
      packSize: m.iUnit, 
      unit: m.mUnit,
      // ✅ Medicine search se master HSN code fill kiya
      hsnCode: m.hsncode || "",
      // Rates ko blank rakha taaki batch se fresh load ho
     gstP: m.gstp || m.gstP || 0,
       mrp: "", sRate: "",
    }));
    setError(""); setSuccess("");
};

  const fetchBatchDetails = async (batchNo) => {
    if (!currentItem?.medID || !batchNo || !batchNo.trim()) return;

    try {
       const res = await customFetch(
            `/MedPurchase/last-batch-details?medId=${currentItem?.medID}&batchNo=${encodeURIComponent(batchNo.trim())}`
        );

        if (res.ok) {
            const data = await res.json();
            
           setCurrentItem(prev => {
    const base = prev || initItem(); 

    const finalHSN = (data?.hsncode && data.hsncode.trim() !== "") 
                     ? data.hsncode 
                     : base.hsnCode;

    const updated = {
        ...base,
        batchNo: batchNo, // Batch No ensure karein
        hsnCode: finalHSN,
        mfgDate: data?.mfgDate || "",
        expDate: data?.expDate || "",
        pRate: data?.pRate || "",
        dis: data?.dis1 || data?.diS1 || "", 
        gstP: data?.gstp || "",
        mrp: data?.mrp || "",
        saleDis: data?.saleDis || "",
        sRate: data?.sRate || ""
    };
    
    // recalcItem ab naya object return karega jo state mein set ho jayega
    return recalcItem(updated); 
});

            setSuccess(`Last history for batch "${batchNo}" loaded.`);
            setError("");
        }
    } catch (err) {
        console.error("Batch fetch error:", err);
    }
};

const recalcItem = (item) => {
  if (!item) return initItem();
  
  const newItem = { ...item };

  // Sare numbers ko parse karein taaki calculations sahi ho
  const packSize = parseFloat(newItem.packSize) || 1;
  const leaf = parseFloat(newItem.leaf) || 0;
  const piece = parseFloat(newItem.piece) || 0;
  const freeLeaf = parseFloat(newItem.freeLeaf) || 0;
  const freePiece = parseFloat(newItem.freePiece) || 0;

  // Quantity Calculation
  const paidPcs = (leaf * packSize) + piece;
  const freePcs = (freeLeaf * packSize) + freePiece;
  const totalPcs = paidPcs + freePcs;

  newItem.totQtyInPcs = round2(paidPcs);
  newItem.freeQty = round2(freePcs);
  newItem.qty = round2(totalPcs); // 🚀 Yeh update hona zaroori hai

  // Rate aur Tax Calculation
  const pRateLeaf = parseFloat(newItem.pRate) || 0;
  const gstPercent = parseFloat(newItem.gstP) || 0;
  const disPercent = parseFloat(newItem.dis) || 0;

  const pieceRate = packSize > 0 ? pRateLeaf / packSize : 0;
  const grossAmount = paidPcs * pieceRate;
  const disAmount = (grossAmount * disPercent) / 100;
  const taxable = grossAmount - disAmount;
  const gstAmt = (taxable * gstPercent) / 100;
  const lineTotal = taxable + gstAmt;

  newItem.taxable = round2(taxable);
  newItem.gstAmt = round2(gstAmt);
  newItem.totals = round2(lineTotal);

  return newItem; 
};
 const applyItemChange = (item, name, value) => {
  // Pehle value update karein
  let newItem = { ...item, [name]: value };
  
  // MRP/Sale Rate Logic
  if (name === "mrp" || name === "saleDis") {
    const mrp = parseFloat(newItem.mrp) || 0;
    const saleDis = parseFloat(newItem.saleDis) || 0;
    if (mrp > 0) newItem.sRate = round2(mrp * (1 - saleDis / 100)).toString();
  }
  if (name === "sRate") {
    const mrp = parseFloat(newItem.mrp) || 0;
    const sRate = parseFloat(newItem.sRate) || 0;
    if (mrp > 0) newItem.saleDis = round2(((mrp - sRate) / mrp) * 100).toString();
  }

  // Phir poore object ko recalculate karke return karein
  return recalcItem(newItem); 
};

  const handleItemChange = (e) => setCurrentItem(applyItemChange(currentItem, e.target.name, e.target.value));

  const handleAddItem = () => {
    if (!currentItem?.medID) { setError("Please select a medicine."); return; }
    if (!currentItem?.batchNo || !currentItem?.batchNo.trim()) { setError("Batch Number is required."); return; }
    if (!currentItem?.hsnCode || !currentItem?.hsnCode.trim()) { setError("HSN Code is required."); return; }
    if (!currentItem?.mfgDate) { setError("Mfg Date is required."); return; }
    if (!currentItem?.expDate) { setError("Expiry Date is required."); return; }
    if (!currentItem?.pRate || Number(currentItem?.pRate) <= 0) { setError("Valid Purchase Rate is required."); return; }
    if (!currentItem?.mrp || Number(currentItem?.mrp) <= 0) { setError("Valid MRP is required."); return; }
    if (!currentItem?.qty || Number(currentItem?.qty) <= 0) { setError("Quantity must be greater than 0."); return; }
    
    setError(""); setSuccess("");
    const itemToAdd = { ...currentItem, oldqty: currentItem?.oldqty || 0 };
    setItems((prev) => [itemToAdd, ...prev]);
   setCurrentItem(initItem());
    setTimeout(() => { if (medicineSelectRef.current) medicineSelectRef.current.focus(); }, 150);
  };

  const handleRemoveItem = (index) => setItems((prev) => prev.filter((_, i) => i !== index));


  const handleEditRowToForm = (index) => {
    const row = items[index];
    console.log("Row Data on Edit:", row);
    if (!row) return;
   const itemToEdit = recalcItem({ ...row });
    console.log("Item to Edit (Mapped):", itemToEdit);
    recalcItem(itemToEdit);
    setCurrentItem(itemToEdit);
    setItems((prev) => prev.filter((_, i) => i !== index));
    setError(""); setSuccess("");
  };

  useEffect(() => {
    const totalTaxable = items.reduce((sum, it) => sum + (parseFloat(it.taxable) || 0), 0);
    const totalGst = items.reduce((sum, it) => sum + (parseFloat(it.gstAmt) || 0), 0);
    const totalAmount = items.reduce((sum, it) => sum + (parseFloat(it.totals) || 0), 0);
    setTotals({ totalTaxable: round2(totalTaxable), totalGst: round2(totalGst), totalAmount: round2(totalAmount) });
  }, [items]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!selectedVendor) { setError("Please select a Vendor."); return; }
    if (!billNo.trim()) { setError("Please enter Bill No."); return; }
    if (items.length === 0) { setError("At least add one medicine."); return; }

    setError(""); setSuccess(""); setLoading(true);
    try {
      const token = getToken();
      const payload = {
        frid: purchaseData.frid || purchaseData.summary?.frid || 1,
        hid: sessionStorage.getItem("hospitalId") || 1,
        vendorId: selectedVendor.vid, billDate, billNo, remarks, transport, entryBy: null,
        cd: parseFloat(headerCD) || 0,
        items: items.map((it) => ({
          medID: it.medID, entryDate: it.entryDate, qty: parseFloat(it.qty) || 0, oldQty: parseFloat(it.oldqty) || 0,
          freeQty: parseFloat(it.freeQty) || 0, totQtyInPcs: parseFloat(it.totQtyInPcs) || 0, pRate: parseFloat(it.pRate) || 0,
          gstP: parseFloat(it.gstP) || 0, taxable: parseFloat(it.taxable) || 0, gstAmt: parseFloat(it.gstAmt) || 0,
          totals: parseFloat(it.totals) || 0, mrp: parseFloat(it.mrp) || 0, sRate: parseFloat(it.sRate) || 0,
          hsnCode: it.hsnCode || "", batchNo: it.batchNo || "", mfgDate: it.mfgDate || null, expDate: it.expDate || null,
          inScheme: parseFloat(it.inScheme) || 0, piece: it.piece ? parseInt(it.piece) : 0, leaf: it.leaf ? parseInt(it.leaf) : 0,
          freeLeaf: it.freeLeaf ? parseInt(it.freeLeaf) : 0, freePiece: it.freePiece ? parseInt(it.freePiece) : 0,
          dis: parseFloat(it.dis) || 0, saleDis: parseFloat(it.saleDis) || 0, cd: parseFloat(it.cd) || 0, cdInDis: parseFloat(it.cdInDis) || 0,
        })),
      };
     const res = await customFetch(`/MedPurchase/update/${purchaseData.purchID}`, {
        method: "PUT", 
        body: JSON.stringify(payload)
      });
      if (!res.ok) throw new Error((await res.text()) || "Failed to update purchase.");
      const data = await res.json();
      setSuccess(`Purchase updated successfully. Bill No: ${data.billNo}`);
      setTimeout(() => { onUpdate(); onClose(); }, 1500);
    } catch (err) { setError(err.message || "Error occurred"); } finally { setLoading(false); }
  };

  if (!show) return null;

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }} onKeyDown={handleKeyDown} tabIndex="-1">
      <div className="modal-dialog modal-xl" style={{ maxWidth: "95%" }}>
        <div className="modal-content shadow-lg border-0">
          <div className="modal-header py-2" style={{ background: 'var(--theme-color, #0088cc)', color: 'white' }}>
            <h6 className="mb-0 fw-bold">Edit Medicine Purchase - {purchaseData?.purchID}</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose} />
          </div>

          <div className="modal-body fs-7 p-3" style={{ maxHeight: "100vh", overflowY: "auto" }}>
            {error && <div className="alert-custom alert-danger py-2 mb-2">{error}</div>}
            {success && <div className="alert-custom alert-success py-2 mb-2">{success}</div>}

            <form ref={formRef} onSubmit={handleUpdate}>
              {/* Vendor Section */}
              <div className="border p-3 mb-3 rounded bg-light section-box">
                <div className="row mb-1 mt-0 align-items-end g-2">
                  <div className="col-md-3">
                    <label className="form-label small mt-0 mb-1 fw-bold text-primary">Search Vendor <span className="text-danger">*</span></label>
                    <AsyncSelect
                      cacheOptions loadOptions={loadVendorOptions} onChange={handleVendorChange} placeholder="Search vendor..."
                      isClearable styles={selectStyles} menuPortalTarget={document.body} menuPosition="fixed"
                      value={selectedVendor ? { value: selectedVendor.vid, label: `${selectedVendor.vendorName} (${selectedVendor.gstin || "No GST"})` } : null}
                    />
                  </div>
                  {selectedVendor && (
                    <>
                      <div className="col-md-2"><label className="form-label small mb-1">Vendor Name</label><input className="form-control form-control-sm bg-white" value={selectedVendor.vendorName} readOnly /></div>
                      <div className="col-md-2"><label className="form-label small mb-1">GSTIN</label><input className="form-control form-control-sm bg-white" value={selectedVendor.gstin || ""} readOnly /></div>
                      <div className="col-md-2"><label className="form-label small mb-1">Mobile No</label><input className="form-control form-control-sm bg-white" value={selectedVendor.mobile || ""} readOnly /></div>
                      <div className="col-md-3"><label className="form-label small mb-1">Address</label><input className="form-control form-control-sm bg-white" value={selectedVendor.address || ""} readOnly /></div>
                    </>
                  )}
                </div>
                <div className="row g-2 mt-1">
                  <div className="col-md-2"><label className="form-label small mb-1">Bill No <span className="text-danger">*</span></label><input className="form-control form-control-sm" value={billNo} required onChange={(e) => setBillNo(e.target.value)} /></div>
                  <div className="col-md-2"><label className="form-label small mb-1">Bill Date <span className="text-danger">*</span></label><input type="date" required className="form-control form-control-sm" value={billDate} onChange={(e) => setBillDate(e.target.value)} /></div>
                  <div className="col-md-2"><label className="form-label small mb-1">Header CD</label><input className="form-control form-control-sm" value={headerCD} onChange={(e) => setHeaderCD(e.target.value)} /></div>
                  <div className="col-md-2"><label className="form-label small mb-1">Transport</label><input className="form-control form-control-sm" value={transport} onChange={(e) => setTransport(e.target.value)} /></div>
                  <div className="col-md-2"><label className="form-label small mb-1">Remarks</label><input className="form-control form-control-sm" value={remarks} onChange={(e) => setRemarks(e.target.value)} /></div>
                <div className="col-md-2"><label className="form-label small mb-1">Entry Date</label><input type="date" className="form-control form-control-sm" name="entryDate" value={currentItem?.entryDate || ""} onChange={handleItemChange} /></div>
                
                </div>
              </div>

              {/* Medicine Entry Section */}
              <div className="border p-3 mb-2 rounded bg-white section-box shadow-sm">
                <div className="row mb-2 g-2">
                  <div className="col-md-4">
                    <label className="form-label small mb-1 fw-bold text-primary">Search Medicine <span className="text-danger">*</span></label>
                    <AsyncSelect
                      ref={medicineSelectRef} cacheOptions loadOptions={loadMedicineOptions} onChange={handleMedicineChange}
                      placeholder="Search medicine..." isClearable styles={selectStyles} menuPortalTarget={document.body} menuPosition="fixed"
                      value={currentItem?.medID ? { value: currentItem?.medID, label: currentItem?.medicineName } : null}
                    />
                  </div>
                  <div className="col-md-3"><label className="form-label small mb-1">Composition</label><input className="form-control form-control-sm bg-light" value={currentItem?.medicinecomposition} readOnly /></div>
                  <div className="col-md-2"><label className="form-label small mb-1">Category</label><input className="form-control form-control-sm bg-light" value={currentItem?.category} readOnly /></div>
                  <div className="col-md-2"><label className="form-label small mb-1">Company</label><input className="form-control form-control-sm bg-light" value={currentItem?.companyName} readOnly /></div>
                  <div className="col-md-1"><label className="form-label small mb-1">Pack</label><input className="form-control form-control-sm bg-light" value={currentItem?.packSize} readOnly /></div>
                </div>

                {/* Input Row 1 */}
                <div className="row g-2 mb-2">
                  <div className="col-md-2"><label className="form-label small mb-1">Batch <span className="text-danger">*</span></label><input className="form-control form-control-sm" name="batchNo" value={currentItem?.batchNo || ""} onChange={handleItemChange} onBlur={(e) => fetchBatchDetails(e.target.value)} /></div>
                   <div className="col-md-1"><label className="form-label small mb-1">HSN<span className="text-danger">*</span></label><input className="form-control form-control-sm" name="hsnCode" value={currentItem?.hsnCode} onChange={handleItemChange} /></div>
                   <div className="col-md-2"><label className="form-label small mb-1">Mfg <span className="text-danger">*</span></label><input type="date" className="form-control form-control-sm" name="mfgDate" value={currentItem?.mfgDate || ""} onChange={handleItemChange} /></div>
                  <div className="col-md-2"><label className="form-label small mb-1">Exp <span className="text-danger">*</span></label><input type="date" className="form-control form-control-sm" name="expDate" value={currentItem?.expDate || ""} onChange={handleItemChange} /></div>
                 
                  <div className="col-md-1"><label className="form-label small mb-1">Leaf</label><input className="form-control form-control-sm" name="leaf" value={currentItem?.leaf} onChange={handleItemChange} /></div>
                  <div className="col-md-1"><label className="form-label small mb-1">Piece</label><input className="form-control form-control-sm" name="piece" value={currentItem?.piece} onChange={handleItemChange} /></div>
                  <div className="col-md-1"><label className="form-label small mb-1">Free Leaf</label><input className="form-control form-control-sm" name="freeLeaf" value={currentItem?.freeLeaf} onChange={handleItemChange} /></div>
                  <div className="col-md-1"><label className="form-label small mb-1">Free Pc</label><input className="form-control form-control-sm" name="freePiece" value={currentItem?.freePiece} onChange={handleItemChange} /></div>
                 
                </div>

                {/* Input Row 2 */}
                <div className="row g-2 mb-2 align-items-end">
                  <div className="col-md-1"><label className="form-label small mb-1">Pur. Rate <span className="text-danger">*</span></label><input className="form-control form-control-sm" name="pRate" value={currentItem?.pRate} onChange={handleItemChange} /></div>
                  
                  <div className="col-md-1"><label className="form-label small mb-1">Dis %</label><input className="form-control form-control-sm" name="dis" value={currentItem?.dis} onChange={handleItemChange} /></div>
                  <div className="col-md-1"><label className="form-label small mb-1">GST %</label><input className="form-control form-control-sm bg-light" name="gstP" value={currentItem?.gstP || ""} readOnly tabIndex="-1" /></div>
                  <div className="col-md-1"><label className="form-label small mb-1">MRP <span className="text-danger">*</span></label><input className="form-control form-control-sm" name="mrp" value={currentItem?.mrp} onChange={handleItemChange} /></div>
                  <div className="col-md-1"><label className="form-label small mb-1">Sale Dis %</label><input className="form-control form-control-sm" name="saleDis" value={currentItem?.saleDis} onChange={handleItemChange} /></div>
                  <div className="col-md-1"><label className="form-label small mb-1">Sale Rate</label><input className="form-control form-control-sm" name="sRate" value={currentItem?.sRate} onChange={handleItemChange} /></div>
                
                  {currentItem?.medID && (
                    <>
                      <div className="col-md-1"><label className="form-label small mb-1">Tot Qty</label><input className="form-control form-control-sm bg-info bg-opacity-10" value={currentItem?.totQtyInPcs} readOnly /></div>
                      <div className="col-md-1"><label className="form-label small mb-1">Free Qty</label><input className="form-control form-control-sm bg-warning bg-opacity-10" value={currentItem?.freeQty} readOnly /></div>
                      <div className="col-md-1"><label className="form-label small mb-1">Taxable</label><input className="form-control form-control-sm" value={currentItem?.taxable} readOnly /></div>
                      <div className="col-md-1"><label className="form-label small mb-1">GST Amt</label><input className="form-control form-control-sm" value={currentItem?.gstAmt} readOnly /></div>
                      <div className="col-md-1"><label className="form-label small mb-1">Amount</label><input className="form-control form-control-sm bg-success text-white fw-bold" value={currentItem?.totals} readOnly /></div>
                    </>
                  )}
                </div>

                {currentItem?.medID && (
                    <div className="text-end">
                      <button type="button" className="btn btn-success btn-sm add-medicine-btn" onClick={handleAddItem}><i className="bi bi-plus-lg me-1"></i>Add Medicine</button>
                    </div>
                )}
              </div>

              {/* Items Table */}
              <div className="table-responsive mb-2 mt-0" style={{ fontSize: "0.8rem", maxHeight: '300px' }}>
                <table className="custom-table table table-sm table-bordered table-hover align-middle text-center mb-0">
                  <thead className="table-dark">
                    <tr>
                      <th>#</th><th>Med Name</th><th>Batch</th><th>Pack</th><th>L</th><th>P</th><th>FL</th><th>FP</th><th>Tot</th><th>Pur Rate</th><th>Dis%</th>
                      <th>GST%</th><th>Sale Rate</th><th>Mfg</th><th>Exp</th><th>Amount</th><th>Act</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.length === 0 ? <tr><td colSpan="17" className="text-muted py-3">No items added.</td></tr> : items.map((it, idx) => (
                      <tr key={idx}>
                        <td>{idx + 1}</td><td className="text-start">{it.medicineName}</td><td>{it.batchNo}</td><td>{it.packSize}</td>
                        <td>{it.leaf}</td><td>{it.piece}</td><td>{it.freeLeaf}</td><td>{it.freePiece}</td><td>{it.qty}</td>
                        <td>{Number(it.pRate || 0).toFixed(2)}</td><td>{Number(it.dis || 0).toFixed(2)}</td><td>{it.gstP}</td>
                        <td>{Number(it.sRate || 0).toFixed(2)}</td><td>{it.mfgDate}</td><td>{it.expDate}</td>
                        <td className="fw-bold text-success">{Number(it.totals || 0).toFixed(2)}</td>
                        <td>
                          <button type="button" className="btn-icon btn-edit" onClick={() => handleEditRowToForm(idx)} tabIndex="-1"><i className="bi bi-pencil-square"></i></button>
                          <button type="button" className="btn-icon btn-delete ms-1" onClick={() => handleRemoveItem(idx)} tabIndex="-1"><i className="bi bi-trash"></i></button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Summary Section */}
              {items.length > 0 && (
                <div className="mt-2 p-2 border rounded bg-info bg-opacity-10 d-flex justify-content-end gap-4 align-items-center">
                  <div className="d-flex align-items-center gap-2"><span className="small fw-bold">Taxable:</span><span className="fw-bold text-dark">{`₹${totals.totalTaxable.toFixed(2)}`}</span></div>
                  <div className="d-flex align-items-center gap-2"><span className="small fw-bold">GST:</span><span className="fw-bold text-dark">{`₹${totals.totalGst.toFixed(2)}`}</span></div>
                  <div className="d-flex align-items-center gap-2"><span className="small fw-bold">Total:</span><span className="fs-6 fw-bold text-success">{`₹${totals.totalAmount.toFixed(2)}`}</span></div>
                </div>
              )}

              <div className="modal-footer px-0 pb-0 pt-3 border-top">
                <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>Cancel</button>
                <button type="submit" className="btn btn-success px-4 fw-bold" disabled={loading || items.length === 0 || !selectedVendor}>
                  {loading ? "Updating..." : "Update Purchase"} <i className="bi bi-save ms-1"></i>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <style jsx>{`
        .form-label { color: #495057; font-weight: 600; font-size: 0.75rem; }
        .form-control-sm, .form-select-sm { font-size: 0.8rem; border-color: #ced4da; }
        .form-control-sm:focus, .form-select-sm:focus { border-color: var(--theme-color, #0088cc); box-shadow: 0 0 0 2px rgba(0, 136, 204, 0.25); }
        .section-box { border-color: #e9ecef !important; }
        .btn-icon { border: none; background: transparent; padding: 0; }
        .btn-edit { color: #0d6efd; }
        .btn-delete { color: #dc3545; }
        .table-hover tbody tr:hover { background-color: #f1f3f5; }
        .alert-custom { padding: 8px 12px; border-radius: 4px; font-size: 0.85rem; font-weight: 500; }
        .alert-danger { background-color: #f8d7da; color: #721c24; border: 1px solid #f5c6cb; }
        .alert-success { background-color: #d4edda; color: #155724; border: 1px solid #c3e6cb; }
      `}</style>
    </div>
  );
};

export default MedPurchaseEditModal;